import {jsPDF} from "jspdf";

import {callAddBoldFont} from "fonts/XuntaSans-Bold-normal";
import {callAddRegularFont} from "fonts/XuntaSans-Regular-normal";
import PDFElements from "base/pdf/PDFElements";

export function useDownloadEntityPDFReport() {
    const download = (entityData = {}, imageUrl) => {
        // See solution to use custom fonts: https://stackoverflow.com/questions/63378821/how-to-add-custom-font-in-jspdf-with-react
        jsPDF.API.events.push(
            ["addFonts", callAddBoldFont],
            ["addFonts", callAddRegularFont]
        );

        let doc = new jsPDF({orientation: "portrait"});

        const image = imageUrl ? doc.getImageProperties(imageUrl) : null;
        const dimensions = image
            ? PDFElements.getPDFDimensions(doc, {x: image.width, y: image.height})
            : null;
        const summaryPositionTop = dimensions
            ? dimensions.summaryPositionTop
            : PDFElements.pagePaddingTop - 10;

        PDFElements.drawHeader(doc, entityData);

        if (imageUrl) {
            // Draw image
            doc.addImage(
                imageUrl,
                "PNG",
                dimensions.imagePositionLeft,
                dimensions.imagePositionTop,
                dimensions.imageWidth,
                dimensions.imageHeight
            );
        }
        // Draw summary table
        entityData.sections.map((section, index) => {
            PDFElements.drawSummaryTable(doc, entityData, section, summaryPositionTop);
        });

        doc.save(`download_${entityData.name}.pdf`);
    };
    return {download};
}
